const propre = (value) => (typeof value === "string" ? value.trim() : "");

export function buildListingImageAlt(listing = {}) {
  const title = propre(listing.title || listing.listing_title || listing.name);
  const category = propre(
    listing.category_label
    || listing.category_name
    || listing.category
    || listing.listing_type_label
    || listing.listing_type
  );
  const city = propre(listing.city || listing.location_city);

  const morceaux = [title ? `Photo de l'annonce « ${title} »` : "Photo de l'annonce"];
  if (category) morceaux.push(`catégorie ${category}`);
  if (city) morceaux.push(`à ${city}`);
  return morceaux.join(" — ");
}

export default buildListingImageAlt;
